export default {
    'ui.contexts': {},
    'ui.forms': {
        'fields': {
            'contexts': ['ui.contexts'],
            'media': ['db.media']
        }
    }
}